"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var removeMessageAd_1 = require("../actions/removeMessageAd");
var store_1 = require("../store/store");
var satcheljs_1 = require("satcheljs");
var owa_analytics_1 = require("owa-analytics");
exports.default = satcheljs_1.mutator(removeMessageAd_1.default, function (actionMessage) {
    var messageAdToRemove = store_1.getStore().messageAdRowStore.get(actionMessage.removeAdId);
    if (messageAdToRemove) {
        owa_analytics_1.logUsage('RemoveNativeAd', {
            adType: messageAdToRemove.adType,
            adMarket: messageAdToRemove.adMarket,
            adRefreshEvent: messageAdToRemove.adRefreshEvent,
        });
        store_1.getStore().messageAdRowStore.delete(actionMessage.removeAdId);
    }
});
//# sourceMappingURL=removeMessageAdMutator.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-messagead-store/lib/mutators/removeMessageAdMutator.js
// module id = 3460
// module chunks = 17 67